import React from 'react';
import { Button } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';

const EnableApplications = ({ closing, onClose }: Props) => {
  return (
    <Base
      header="Enable Applications"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <>
          <Button text="Enable" onClick={() => onClose(true)} />
          <Button text="Cancel" variant="secondary" onClick={() => onClose(false)} />
        </>
      }
    >
      <div className="reject-application-modal">
        <p className="title body strong">Would you like to enable Staff Application System?</p>
      </div>
    </Base>
  );
};

export default EnableApplications;
